import translate from '@yandex-delivery/core/i18n/translate'
import {getTranslator} from '@yandex-delivery/guts-revealer/get-translator'
import {window} from '@yandex-delivery/utils'

import {appConfig} from './app-config'
import {__I18N_KEY__} from './consts'

export const i18n =
  typeof window === 'undefined'
    ? translate(appConfig.lang || 'ru', {})
    : getTranslator(translate(appConfig.lang || 'ru', window[__I18N_KEY__]), {
        isGutsRevealerEnabled: Boolean(appConfig.experiments3?.guts_revealer),
      })
